<div class="main-container">

    <div class="loading-container" *ngIf="isLoading">
      <div class="lds-grid">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  
    <!-- <div *ngIf="!isValidRefNo" style="background-color: lightpink;">
      <h1>Invalid RefNo {{refNo}}. This claim either could be archived or not yet registered. Please contact Mk3 IT-Helpdesk </h1>
    </div> -->
<div *ngIf="!isValidRefNo" style="display: grid; justify-content: center; ">
    <div class="alert alert-danger" style="width: 70vw; max-width: 100%;margin-top: 20px;">
      <a class="close" (click)="openInputRefNoDialog()">&times;</a>
      <span >Invalid RefNo '
        {{refNo}}
        '. This claim either could be archived or not yet registered. Please re-enter RefNo to search again, or contact Mk3 IT-Helpdesk</span>
    </div>
</div>

    <div *ngIf="isValidRefNo">
      <h1>Mk3 Claim Instruction(s) for RefNo {{refNo}}</h1>
            <div class="search-box-container">
              <mat-form-field class="search-box-form-field">
                <mat-label>Search by Keyword</mat-label>
                <input #searchAll matInput type="text" (keyup)="onSearchKeyUp(searchAll,'all')"
                [value]="searchValueInstructionAll" autoFocus>
              <button mat-button matSuffix mat-icon-button aria-label="Clear"
                (click)="onClearClicked(searchAll,'All')">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <table mat-table class="mat-elevation-z8 table-striped" [dataSource]="dataSourceEmailRecords" matSort
              matSortStart="asc">
              <ng-container matColumnDef="id">
                <th class="w-1" style="text-align: left;" mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
                <td mat-cell *matCellDef="let emailRecords">{{emailRecords.id}}</td>
              </ng-container>
              <ng-container matColumnDef="tradeName">
                <th class="w-3" style="text-align: left;" mat-header-cell *matHeaderCellDef mat-sort-header>Trade Name</th>
                <td mat-cell *matCellDef="let emailRecords">{{emailRecords.tradeName}}</td>
              </ng-container>
              <ng-container matColumnDef="instructionTypeId">
                <th class="w-3" mat-header-cell *matHeaderCellDef mat-sort-header>Instruction Type</th>
                <td mat-cell *matCellDef="let instructionTypes">{{instructionTypes.instructionType}}
                </td>
              </ng-container>
              <ng-container matColumnDef="attachmentName">
                <th class="w-10" style="text-align: left;" mat-header-cell *matHeaderCellDef mat-sort-header>Attachment
                  Name</th>
                <td mat-cell *matCellDef="let emailRecords">{{emailRecords.attachmentName}}</td>
              </ng-container>

              <ng-container matColumnDef="sentBy">
                <th class="w-3" mat-header-cell *matHeaderCellDef mat-sort-header>Sent By</th>
                <td mat-cell *matCellDef="let emailRecords">{{emailRecords.sentBy}}</td>
              </ng-container>

              <ng-container matColumnDef="dateSent">
                <th class="w-5" mat-header-cell *matHeaderCellDef mat-sort-header>Sent On</th>
                <td mat-cell *matCellDef="let emailRecords">{{emailRecords.dateSent | date: 'dd/MM/yyyy HH:mm'}}</td>
              </ng-container>

              <ng-container matColumnDef="statusId">
                <th class="w-5" mat-header-cell *matHeaderCellDef mat-sort-header>Job Status</th>
                <td mat-cell *matCellDef="let emailRecords">{{getJobStatus(emailRecords.statusId)}}</td>
              </ng-container>

              <ng-container matColumnDef="details">
                <th class="w-1" mat-header-cell *matHeaderCellDef mat-sort-header></th>
                <td mat-cell style="white-space: nowrap;" *matCellDef="let emailRecords">
                  <button mat-raised-button class="btn btn-sm btn-success"
                    [hidden]="(emailRecords.instructionTypeId == 2 || emailRecords.instructionTypeId == 4)"
                    (click)="jobDetails(emailRecords.id)">Details</button>&nbsp;&nbsp;
                </td>
              </ng-container>

              <ng-container matColumnDef="viewDocument">
                <th class="w-1" mat-header-cell *matHeaderCellDef mat-sort-header></th>
                <td mat-cell *matCellDef="let emailRecords">
                  <button style="width: fit-content;" mat-raised-button class="btn btn-sm btn-primary"
                    (click)="openInstructionPDF(emailRecords.id)">PDF</button>
                </td>
              </ng-container>

              <ng-container matColumnDef="retract">
                <th class="w-1" mat-header-cell *matHeaderCellDef mat-sort-header></th>
                <td mat-cell style="white-space: nowrap;" *matCellDef="let emailRecords">
                  <button mat-raised-button class="btn btn-sm btn-danger"
                  [hidden]="(emailRecords.instructionTypeId == 2 || emailRecords.instructionTypeId == 4)"
                  [disabled]="(emailRecords.retracted) || ((!emailRecords.retracted) && (emailRecords.statusId == 9 || emailRecords.statusId == 10))"
                  (click)="retract(emailRecords.id)">
                  <div *ngIf="emailRecords.retracted" class="btn-disabled">Retracted</div>
                  <div *ngIf="(!emailRecords.retracted) && !(emailRecords.statusId == 9 || emailRecords.statusId == 10)">&nbsp;&nbsp;Retract&nbsp;&nbsp;
                  </div>
                  <div *ngIf="(!emailRecords.retracted) && (emailRecords.statusId == 9 || emailRecords.statusId == 10)" class="btn-disabled">
                    &nbsp;&nbsp;Retract&nbsp;&nbsp;</div>
                </button>
                  &nbsp;&nbsp;
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedEmailRecordsColumns"></tr>
              <tr mat-row class="row-hover mat-row" *matRowDef="let row; columns: displayedEmailRecordsColumns;"
              [ngClass]="{'highlight-table-row': row.statusId == 2 || row.statusId == 10}"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="9999">
                  No Instructions available for this Claim {{searchValueInstructionAll ? ', with the serch keyword filter of "'+searchValueInstructionAll+'"':''}} 
                </td>
              </tr>
            </table>
            <mat-paginator *ngIf="dataSourceEmailRecords" #paginator 
             showFirstLastButtons [pageSize]="pageSizeControl.value" 
             [pageSizeOptions]="[5, 15, 50, 100, dataSourceEmailRecords.data.length]" 
             (page)="onPageSizeChange()">
            </mat-paginator>
  </div>
</div>
    
